export enum RoundedDirections {
  bottom,
  top,
  left,
  right,
}
